export default __webpack_public_path__ + "static/media/DSC_7980.fa774948.jpg";